/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'user': {
    width: 23,
    height: 23,
    viewBox: '0 0 23 23',
    data: `<defs><clipPath id="svgicon_user_a"><path pid="0" d="M0 0h23v23H0z"/></clipPath></defs><g clip-path="url(#svgicon_user_a)"><path pid="1" d="M16.214 5.276a4.745 4.745 0 01-4.714 4.776 4.746 4.746 0 01-4.714-4.776A4.746 4.746 0 0111.5.5a4.746 4.746 0 014.714 4.776zM20.5 22.5h-18v-4.981a4.829 4.829 0 014.8-4.861h8.4a4.832 4.832 0 014.8 4.863z" _fill="none" _stroke="currentColor"/></g>`
  }
})
/* tslint:enable */
